import Swal from 'sweetalert2';
import axios from '../../axios';
import {
   ADD_ACCOUNT,
   MULTI_DELETE_ACCOUNT,
   DELETE_ACCOUNT,
   GET_ACCOUNT,
   GET_ACCOUNTS,
   GET_ACCOUNTS_FOR_CASH_BANK,
   GET_ACCOUNTS_FOR_DASHBOARD,
   GET_ACCOUNTS_FOR_MASTER,
   GET_CUSTOMER,
   GET_VENDORS,
   UPDATE_ACCOUNT,
   EMPTY_ACCOUNT,
   GET_ACCOUNT_BROKER,
   GET_SUSPENSE_ACCOUNTS,
} from '../types';
import { toast } from 'react-toastify';

// export const getAccount = (params) => async (dispatch) => {
//   try {
//     const res = await axios.get('/account/all', { params });

//     if (res.data.code === 1) {
//       dispatch({ type: GET_ACCOUNTS, payload: res.data.data });
//       return Array.isArray(res.data.data) ? res.data.data : []; // ✅ Always return an array
//     }

//     if (res.data.code === 2) {
//       setTimeout(() => {
//         toast.warn(res.data.message);
//       }, 1000);
//       return []; // ✅ Return empty array for no data
//     }
//   } catch (err) {
//     if (err.response?.data?.message) {
//       toast.error(err.response.data.message);
//     }
//     return []; // ✅ Ensure it always returns an array
//   }
// };

export const getAccountForDashboard = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/account/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_ACCOUNTS_FOR_DASHBOARD,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         return res.data.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getAccount = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/account/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_ACCOUNTS,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getAccountForCashBank = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/account/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_ACCOUNTS_FOR_CASH_BANK,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getAccountForMaster = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/account/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_ACCOUNTS_FOR_MASTER,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getSuspenseAccount = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/account/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_SUSPENSE_ACCOUNTS,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getAccountById = (params) => async (dispatch) => {
   try {
      // const res = await axios.get(`/account/${id}`);
      const res = await axios.get('/account/id', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_ACCOUNT, payload: res.data.data, single: res.data.data });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      console.log('err', err.response);
      if (err?.response?.data?.message) {
         toast.error(err?.response?.data?.message);
      }
      // console.error('Failed to add customer. Please try again.');
   }
};

export const getBrokerById = (params) => async (dispatch) => {
   try {
      // const res = await axios.get(`/account/${id}`);
      const res = await axios.get('/account/id', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_ACCOUNT_BROKER, payload: res.data.data, single: res.data.data });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      console.log('err', err.response);
      if (err?.response?.data?.message) {
         toast.error(err?.response?.data?.message);
      }
      // console.error('Failed to add customer. Please try again.');
   }
};

export const addAccount = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/account/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_ACCOUNT, payload: res.data.data });
         localStorage.setItem('accountId', res?.data?.data?.id);
         localStorage.setItem('accountData', JSON.stringify(res?.data?.data));
         setTimeout(() => {
            toast.success('Account added successfully!');
         }, 1000);
         return res.data;
      } else {
         toast.error('Failed to add Account. Please try again.');
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.warn(err.response.data.message);
         return;
      }
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const updateAccount = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/account/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_ACCOUNT, payload: res.data.data });

         setTimeout(() => {
            toast.success('Account updated successfully!');
         }, 1000);
      }
      // else {
      //   toast.error('Failed to update account. Please try again.');
      // }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};

// Delete Customer
export const deleteCustomer = (id, companyId) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/account/delete/${id}/${companyId}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_ACCOUNT, payload: { id } });
         Swal.fire({
            icon: 'success',
            title: res.data.message || 'Customer deleted successfully!',
            showConfirmButton: false,
            timer: 1000, // auto-close in 0.5 seconds
         });
         // toast.success(res.data.message || 'Customer deleted successfully!');
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to delete Customer. Please try again.');
   }
};

export const multiDeleteCustomer = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/account/delete/multi`, formData);

      if (res.data.code === 1) {
         dispatch({ type: MULTI_DELETE_ACCOUNT, payload: res.data.data });

         setTimeout(() => {
            toast.success('Account deleted successfully!');
         }, 1000);
      }
      // else {
      //   toast.error('Failed to update account. Please try again.');
      // }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};

// export const updateStatus = (data) => async (dispatch) => {
//   const res = await axios.post('/account/update/status', data);
//   if (res.data.code === 1) {
//     dispatch({ type: UPDATE_ACCOUNT, payload: res.data.data });
//     toast.success('Status updated successfully!');
//   }
//   if (res.data.code === 2) {
//     toast.warn(res.data.message);
//   }
//   return res.data.code;
// };

export const updateStatus =
   ({ id, status }) =>
      async (dispatch) => {
         try {
            // const data = {
            //   id,
            //   status: status ? 1 : 0, // Convert boolean to integer (1 for true, 0 for false)
            // };

            const res = await axios.post('/account/update/status', { id, status });

            if (res.data.code === 1) {
               dispatch({ type: UPDATE_ACCOUNT, payload: res.data.data });
               toast.success('Status updated successfully!');
            } else if (res.data.code === 2) {
               toast.warn(res.data.message);
            } else {
               toast.error('Failed to update status. Please try again.');
            }

            return res.data.code;
         } catch (error) {
            toast.error('An error occurred while updating status.');
            console.error('Error updating status:', error);
            return 0; // Return 0 to indicate failure
         }
      };

export const emptyAccount = () => async (dispatch) => {
   dispatch({ type: EMPTY_ACCOUNT, payload: null });
};

export const uploadDocument = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/account/addImg', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_ACCOUNT, payload: res.data.data });
         toast.success(res.data.message);
         return res.data;
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // toast.error('Failed to upload document. Please try again.');
   }
};

export const sendVerifyOtp = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/account/sendVerifyOtp', data);

      if (res.data.code === 1) {
         dispatch({ type: GET_CUSTOMER, payload: res.data.data });
         toast.success(res.data.message);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
      return res.data;
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
         return err.response.data;
      }
   }
};

export const deleteDocument = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/account/deleteImg', formData);
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_ACCOUNT, payload: res.data.data });
         toast.success(res.data.message);
         return res.data;
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // toast.error('Failed to upload document. Please try again.');
   }
};
